import MatchedMap from 'utilities/src/matchedMap';

import { BlogVariantEnum } from '../_variants';

import buttonAccentClasses from './_accent';
import buttonDangerClasses from './_danger';
import buttonGhostClasses from './_ghost';
import buttonNeutralClasses from './_neutral';
import buttonNeutralOutlinedClasses from './_neutralOutlined';
import buttonPrimaryClasses from './_primary';
import buttonPrimaryLightClasses from './_primaryLight';
import buttonPrimaryOutlinedClasses from './_primaryOutlined';
import buttonSecondaryGreenClasses from './_secondaryGreen';
import buttonSecondaryPurpleClasses from './_secondaryPurple';
import buttonWhiteClasses from './_white';
import buttonWhiteOutlinedClasses from './_whiteOutlined';

const buttonBlogVariantClassesMap = new MatchedMap([
  [BlogVariantEnum.Accent, buttonAccentClasses],
  [BlogVariantEnum.Danger, buttonDangerClasses],
  [BlogVariantEnum.Ghost, buttonGhostClasses],
  [BlogVariantEnum.Neutral, buttonNeutralClasses],
  [BlogVariantEnum.NeutralOutlined, buttonNeutralOutlinedClasses],
  [BlogVariantEnum.Primary, buttonPrimaryClasses],
  [BlogVariantEnum.PrimaryLight, buttonPrimaryLightClasses],
  [BlogVariantEnum.PrimaryOutlined, buttonPrimaryOutlinedClasses],
  [BlogVariantEnum.SecondaryGreen, buttonSecondaryGreenClasses],
  [BlogVariantEnum.SecondaryPurple, buttonSecondaryPurpleClasses],
  [BlogVariantEnum.White, buttonWhiteClasses],
  [BlogVariantEnum.WhiteOutlined, buttonWhiteOutlinedClasses],
]);

export default buttonBlogVariantClassesMap;
